import { render, staticRenderFns } from "./TollRoadsPage.vue?vue&type=template&id=4848ebdf&scoped=true"
import script from "./TollRoadsPage.vue?vue&type=script&lang=js"
export * from "./TollRoadsPage.vue?vue&type=script&lang=js"
import style0 from "./TollRoadsPage.vue?vue&type=style&index=0&id=4848ebdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848ebdf",
  null
  
)

export default component.exports